import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useReducer } from 'react';
import { createGlobalStyle } from 'styled-components';
import { Canvas } from '../Canvas';
import { LoadingIndicator } from '../LoadingIndicator';
import { Stage } from '../Stage';
const GlobalStyle = createGlobalStyle `
    body {
        --Stage_PaddingTop: 0rem;
        --Stage_PaddingBottom: 0rem;
        --Stage_PaddingLeft: 0rem;
        --Stage_PaddingRight: 0rem;
    }
`;
export function EmbeddedView({ streamPartId }) {
    const [ready, setReady] = useReducer(() => true, false);
    return (_jsxs(_Fragment, { children: [_jsx(GlobalStyle, {}), _jsx(LoadingIndicator, { loading: !ready }), _jsx(Stage, { children: _jsx(Canvas, { streamPartId: streamPartId, onReady: setReady }) })] }));
}
